// Lightweight renderer for simple markdown (**bold**, # headings, line breaks).
export default function AiText({ text, className = "" }) {
  const lines = (text || "").split("\n");
  const render = (str) =>
    str.split(/(\*\*[^*]+\*\*)/g).map((seg, i) =>
      seg.startsWith("**") && seg.endsWith("**")
        ? <strong key={i} className="text-white font-semibold">{seg.slice(2, -2)}</strong>
        : <span key={i}>{seg}</span>
    );
  return (
    <div className={`space-y-2 text-sm leading-relaxed text-slate-300 ${className}`}>
      {lines.map((ln, i) => {
        const t = ln.trim();
        if (!t) return <div key={i} className="h-1" />;
        if (t.startsWith("# ")) return <p key={i} className="text-base font-semibold text-white">{render(t.slice(2))}</p>;
        if (t.startsWith("## ")) return <p key={i} className="text-sm font-semibold text-white">{render(t.slice(3))}</p>;
        if (/^[-*]\s/.test(t)) return <p key={i} className="pl-3">• {render(t.replace(/^[-*]\s/, ""))}</p>;
        return <p key={i}>{render(t)}</p>;
      })}
    </div>
  );
}
